/**
 * Pen palette as concrete hex so ColorPicker, Plotly, and uPlot never see
 * Tailwind's `oklch(...)`. Same library hues as the Foundations color grid
 * (neutrals omitted), at 500 then 300 then 700.
 *
 * Hue order is categorical, not wheel order: neighboring pens jump around
 * the spectrum so adjacent series stay distinct instead of reading as a
 * rainbow.
 */
const TAILWIND_PEN_HEX = {
  red: { 300: '#FFA2A2', 500: '#FB2C36', 700: '#C10007' },
  orange: { 300: '#FFB86A', 500: '#FF6900', 700: '#CA3500' },
  amber: { 300: '#FFD230', 500: '#FE9A00', 700: '#BB4D00' },
  yellow: { 300: '#FFDF20', 500: '#F0B100', 700: '#A65F00' },
  lime: { 300: '#BBF451', 500: '#7CCF00', 700: '#497D00' },
  green: { 300: '#7BF1A8', 500: '#00C950', 700: '#008236' },
  emerald: { 300: '#5EE9B5', 500: '#00BC7D', 700: '#007A55' },
  teal: { 300: '#46ECD5', 500: '#00BBA7', 700: '#00786F' },
  cyan: { 300: '#53EAFD', 500: '#00B8DB', 700: '#007595' },
  sky: { 300: '#74D4FF', 500: '#00A6F4', 700: '#0069A8' },
  blue: { 300: '#8EC5FF', 500: '#2B7FFF', 700: '#1447E6' },
  indigo: { 300: '#A3B3FF', 500: '#615FFF', 700: '#432DD7' },
  violet: { 300: '#C4B4FF', 500: '#8E51FF', 700: '#7008E7' },
  purple: { 300: '#DAB2FF', 500: '#AD46FF', 700: '#8200DB' },
  fuchsia: { 300: '#F4A8FF', 500: '#E12AFB', 700: '#A800B7' },
  pink: { 300: '#FDA5D5', 500: '#F6339A', 700: '#C6005C' },
  rose: { 300: '#FFA1AD', 500: '#FF2056', 700: '#C70036' },
} as const

type PenHue = keyof typeof TAILWIND_PEN_HEX

const PEN_HUE_ORDER = [
  'blue',
  'orange',
  'emerald',
  'violet',
  'rose',
  'yellow',
  'cyan',
  'fuchsia',
  'lime',
  'indigo',
  'pink',
  'teal',
  'amber',
  'sky',
  'purple',
  'red',
  'green',
] as const satisfies readonly PenHue[]

const PEN_STEPS = [500, 300, 700] as const

export const SENSOR_COLORS_HEX: string[] = PEN_STEPS.flatMap((step) =>
  PEN_HUE_ORDER.map((hue) => TAILWIND_PEN_HEX[hue][step])
)

export const getSensorColor = (sensorIndex: number) => {
  return SENSOR_COLORS_HEX[sensorIndex % SENSOR_COLORS_HEX.length]
}
